export interface SimpleReactionSettings {
  trials: number;
  signalColor: 'green' | 'red' | 'blue' | 'white' | 'gray';
}

export type DifficultyLevel = 'easy' | 'medium' | 'hard';

export interface DiscriminationReactionSettings {
  trials: number;
  difficulty: DifficultyLevel;
}

export interface HardwareTestSettings {
  trials: 4 | 20;
}

export interface Settings {
  simpleReaction: SimpleReactionSettings;
  discriminationReaction: DiscriminationReactionSettings;
  hardwareTest: HardwareTestSettings;
  isExpertMode: boolean;
}

export const COLOR_OPTIONS = [
  { label: 'Rot', value: 'red' },
  { label: 'Grün', value: 'green' },
  { label: 'Blau', value: 'blue' },
  { label: 'Weiß', value: 'white' },
  { label: 'Grau', value: 'gray' },
] as const

export const DIFFICULTY_OPTIONS = [
  { label: 'Leicht (Stufe 1: 1 Reaktionssignal vs. 1 Fehlersignal)', value: 'easy' },
  { label: 'Mittel (Stufe 2: 2 Reaktionssignale vs. 2 Fehlersignale)', value: 'medium' },
  { label: 'Schwer (Stufe 3: 3 Reaktionssignale vs. 3 Fehlersignale)', value: 'hard' },
] as const

export const DEFAULT_SETTINGS: Settings = {
  simpleReaction: {
    trials: 10,
    signalColor: 'red',
  },
  discriminationReaction: {
    trials: 10,
    difficulty: 'easy',
  },
  hardwareTest: {
    trials: 20,
  },
  isExpertMode: false,
};
